import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { maxMediaQueries, hoverMediaQuery } from '@finect/tabular-utils/mediaQueries';
var transparentStyles = css(["border-color:rgb(255 255 255 / 0.25);background-color:transparent;", " color:#fff;span{border-color:rgb(255 255 255 / 0.25);}"], fontSmoothing);
var followingStyles = css(["border:1px solid ", ";background-color:", ";", " color:", ";span{padding-left:11px;border-left:1px solid rgb(255 255 255 / 0.25);margin-left:12px;", ";font-weight:400;", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.followedColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.followedColor;
}, fontSmoothing, function (_ref3) {
  var theme = _ref3.theme;
  return theme.followedFontColor;
}, getFont(-1), maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      display: none;\n    "]))));
var notFollowinfStyles = css(["border:1px solid ", ";background-color:#fff;span{padding-left:11px;border-left:1px solid ", ";margin-left:12px;", ";font-weight:400;font-feature-settings:'tnum';", ";}", ";", ";"], function (_ref4) {
  var theme = _ref4.theme,
    noBorder = _ref4.noBorder;
  return noBorder ? 'transparent' : theme.borderColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderColor;
}, getFont(-1), maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      display: none;\n    "]))), function (_ref6) {
  var transparent = _ref6.transparent;
  return transparent && transparentStyles;
}, hoverMediaQuery(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    &:hover {\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n\n      span {\n        border-color: ", ";\n      }\n    }\n  "])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.followHoverColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.followHoverColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.followHoverFontColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primaryL;
}));
var defaultStyles = css(["padding:0 15px;", ";line-height:34px;"], getFont(0));
var smallStyles = css(["padding:0 9px;", ";line-height:25px;"], getFont(-1));
export var FollowButton = styled.button.withConfig({
  displayName: "FollowButton",
  componentId: "sc-183uxhj-0"
})(["border-radius:", ";margin-left:9px;cursor:pointer;font-family:", ";font-weight:600;transition:all 0.15s ease;", ";", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.borderRadius;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.bodyFontFamily;
}, function (_ref13) {
  var small = _ref13.small;
  return small ? smallStyles : defaultStyles;
}, function (_ref14) {
  var following = _ref14.following;
  return following ? followingStyles : notFollowinfStyles;
});